import React from "react";
import { useSearchBox } from "react-instantsearch-hooks-web";

function SearchInput({ onModeChange }) {
	const { query, refine } = useSearchBox();

	function handleChange(e) {
		const nextQuery = e.target.value;
		onModeChange(nextQuery.trim().length > 0);
		refine(nextQuery); // important: update query AFTER toggling mode
	}

	console.log("Query:", query);


	return (
		<input
			className="form-control"
			placeholder="Search Drive"
			type="text"
			value={query}
			onChange={handleChange}
		/>
	);
}

export default SearchInput;
